module.exports = __webpack_public_path__ + "img/logo-surf.f3f84051.png";